// extracted by mini-css-extract-plugin
export var blockUpcomingEvents = "UpcomingEvents-module--block-upcoming-events--2wzKw";